$(() => {
    $(window).scroll(function(){
        if ($(this).scrollTop() > 700) {
            $('.header-fix').addClass('fixed');
        } else {
            $('.header-fix').removeClass('fixed');
        }
    });
});
